import api from '../utils/functions/api';

const baseURL = process.env.REACT_APP_API_URL;

async function createCompanyApi(company, imageLogoBlob) {
    const formData = new FormData();
    formData.append('json', JSON.stringify(company))
    formData.append('file', imageLogoBlob);

    try {
        const resp = await api.post(`${baseURL}/super-admin/addCompanies`, formData);

        return resp.data;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

async function getCompanyListApi() {
    try {
        const resp = await api.get(`${baseURL}/super-admin/getCompanies`);

        return resp.data;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

async function deleteCompanyApi(_id) {
    try {
        const resp = await api.delete(`${baseURL}/super-admin/deleteCompanies/${_id}`);

        return resp.data;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

async function updateCompanyApi(_id, companies, imageLogoBlob) {
    try {
        const formData = new FormData();
        formData.append('json', JSON.stringify(companies))
        formData.append('file', imageLogoBlob);

        const resp = await api.put(`${baseURL}/super-admin/updateCompanies/${_id}`, formData);

        return resp;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

async function getCompanyDetailApi(_id) {
    try {
        const { data } = await api.get(`${baseURL}/super-admin/company/${_id}`);

        return data;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

async function getTemplateApi() {
    try {
        const resp = await api.get(`${baseURL}/super-admin/pdfTemplates`);

        return resp.data;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

async function getCheckPathMerchant(path) {
    try {
        const resp = await api.get(`${baseURL}/super-admin/check-merchant/${path}`);

        return resp.data
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
	}
}

async function getCompanyUrlPath () {
    try {
        const uri = `${baseURL}/merchant/login-link`;
        const response = await api.get(uri)

        return response?.data?.urlPath
    } catch (error) {
        throw new Error(error.message);
    }
}

async function getTaxIdCompanyListApi() {
    try {
        const resp = await api.get(`${baseURL}/super-admin/getCompanies`);
        const company = resp?.data.company
        const result = company.map((c) => ({ tax_id: c.tax_id }));

        return result;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

async function getSettingShowUserLogin () {
    try {
        const uri = `${baseURL}/merchant/setting-show-user-link`;
        const { data: response } = await api.get(uri)

        return response?.isShowButtonUserLogin
    } catch (error) {
        throw new Error(error.message);
    }
}

const CompanyListApi = {
    createCompanyApi,
    getCompanyListApi,
    deleteCompanyApi,
    updateCompanyApi,
    getCompanyDetailApi,
    getTemplateApi,
    getCheckPathMerchant,
    getCompanyUrlPath,
    getTaxIdCompanyListApi,
    getSettingShowUserLogin,
};
export default CompanyListApi;
